<template>
  <van-popup v-model="showCoupon" position="bottom" @close="closePopup">
    <div class="popup-top">
      <van-divider contentPosition="center" customStyle="color: #868686;">选择代金劵</van-divider>
    </div>
    <div class="group-main">
      <van-tabs color="#C89884" tab-active-class="active-tab-coupon" animated>
        <van-tab title="可用代金劵" >
          <div class="couponList flex-csc" v-if="couponList && couponList.length > 0">
            <van-checkbox-group class="checkbox-group" v-model="setCouponIds" checked-color="#FA4E26">
              <van-cell-group>
                <van-cell
                    v-for="(item, index) in couponList"
                    clickable
                    :key="index"
                    @click="toggle(index, item)"
                >
                  <div class="coupon-item flex-rsc">
                    <div class="left-content">
                      <div class="money"><span>¥</span>{{item.maxAmountStr}}</div>
                      <span class="text">{{item.amountStr}}抵{{item.maxAmountStr}}代金劵</span>
                    </div>
                    <div class="right-content flex-1">
                      <div class="coupon-title">{{item.couponName}}</div>
                      <div class="flex-rbc">
                        <div class="time">{{item.dateStr}}</div>
                        <van-checkbox slot="right-icon" :name="item.couponId" ref="checkboxes" :disabled="cashMoney <= 0 && !item.select"></van-checkbox>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div v-else>
            <no-data text="暂无可用代金劵" type="coupon"></no-data>
          </div>
        </van-tab>
        <van-tab title="不可用代金劵">
          <div class="couponList flex-csc" v-if="UnCashCoupon && UnCashCoupon.length > 0">
            <div class="coupon-item flex-rsc" v-for="(item, index) in UnCashCoupon" :key="index">
              <div class="left-content">
                <div class="money"><span>¥</span>{{item.maxAmountStr}}</div>
                <span class="text">{{item.amountStr}}抵{{item.maxAmountStr}}代金劵</span>
              </div>
              <div class="right-content flex-1">
                <div class="coupon-title">{{item.couponName}}</div>
                <div class="flex-rbc">
                  <div class="time">{{item.dateStr}}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <no-data text="暂无不可用代金劵" type="coupon"></no-data>
          </div>
        </van-tab>
      </van-tabs>

    </div>
    <div class="popup-btn flex-ccc">
      <button class="button-default wx-button-primary" @click="changeProject">确定</button>
    </div>
  </van-popup>
</template>

<script>
  import noData from '@/components/coupon/noCoupon'
  import { Dialog } from 'vant';
  export default {
    props: ['couponList', 'showCoupon', 'setCouponIds', 'setCashCouponArr', 'UnCashCoupon', 'discountCouponObj', 'cashCouponM'],
    data () {
      return {
        mechInfo: {},
        checkArr: []
      }
    },
    computed: {
      cashMoney () {
        let M = 0
        this.couponList.forEach(item => {
          if (item.select) {
            M += (item.maxAmountStr * 100)
          }
        })
        return this.cashCouponM - M / 100
      }
    },
    components: {
      noData
    },
    methods: {
      closePopup () {
        this.$emit('closePopup')
      },
      changeProject () {
        const {discountCouponObj, setCouponIds} = this
        if (discountCouponObj && discountCouponObj.amountStr && setCouponIds.length > 0) {
          Dialog.confirm({
            title: '标题',
            message: '优惠劵和代金劵不能同时使用，是否要放弃代金劵？'
          }).then(() => {
            this.$emit('cashPopup', this.setCouponIds)
          }).catch(() => {
            this.$emit('closePopup')
          })
        } else {
          this.$emit('cashPopup', this.setCouponIds)
        }
      },
      toggle(index, item) {
        if (this.cashMoney <= 0 && !item.select) {
          return
        }
        // this.$refs.checkboxes[index].toggle()
        let limit = this.couponList[0].limit || 1
        if (this.setCouponIds.length >= limit) {
          let msg = `代金劵不能选择超过${limit}张`
          this.$toast(msg)
          return
        }
        let arr = []
        this.couponList[index].select = !this.couponList[index].select
        this.couponList.forEach(coupon => {
          if (coupon.select) {
            arr.push(coupon.couponId)
          }
        })
        this.setCouponIds = arr
        console.log('setCouponIds', this.setCouponIds)
      }
    }
  }
</script>

<style scoped lang="stylus">
  .popup-top
    padding 0 50px
  .group-main
    padding 5px 0
    overflow-y scroll
    height 260px
    .group-tit
      font-size 12px
      color $sixColor
    .van-checkbox
      padding 5px
    .artificer-list
      margin-top 10px
  .popup-btn
    padding 10px 20px
    overflow hidden
  .artificer
    padding-bottom 4px
    border 1px solid #fff
    &.active
      border 1px solid $blueColor
    margin-right 12px
    img
      width 72px
      height 90px
    .name
      text-align center
      font-size 14px
      color $blackColor
      line-height 2em
    .years
      text-align center
      font-size 12px
      color $grayColor
  >>>.van-checkbox__label
    width 80vw !important

.couponList
  width 100vw
  .coupon-item
    display: flex;
    flex-direction: row;
    width 325px
    height 94px
    background url("../../assets/images/coupon-bg.png") no-repeat
    background-size cover
    .left-content
      text-align center
      padding 10px
      width 30%
      .money
        font-weight 500
        text-align center
        font-size 34px
        color $redColor
        span
          font-size 23px
      .text
        padding 2px 4px
        font-size 10px
        background $blueColor
        border-radius 18px
        margin-top 7px
        color #fff
    .right-content
      padding 0 14px 0 4px
      .coupon-title
        font-size 14px
        font-weight 500
        color $blackColor
        text-align left
      .time
        font-size 12px
        color $grayColor
</style>
